export default "__VITE_ASSET__CcGqP3oX__"